import React, { useContext, useEffect, useState, useRef } from "react";
import { Button, Col, Row, Spinner } from "reactstrap";
import { FormInput } from "Components/InputComponents/FormInput";
import { useForm } from "react-hook-form";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import {
  BASE_URL,
  POST_CREATE_USER,
  UPDTAE_SINGLE_USER,
} from "utilFunctions/Constants/urlConstants";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { SelectHookForm } from "Components/InputComponents/SelectHookForm";
import useMasterContext from "Context/MasterContext";
import "./index.css";
import {
  getOptionIndex,
  getOptionIndexMultiForBranch,
  getOptionIndexMultiWithObject,
  returnMultipleValues,
} from "utilFunctions/helperFunctions/HelperFunction";
import { Status } from "utilFunctions/Constants/Constants";
import Typography from "Components/CommonComponents/Typography";
import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
export type LoginFormFields = {
  name: string;
  email: string;
  password?: string;
  employeeId: string;
  superwisorEmployeeId: string;
  supervisorEmail: string;
  user_theme?: string;
  department?: string;
  region?: any;
  branch?: any;
  status?: any;
  fexRole?: any;
  stream?: any;
  subject?: any;
  subjects?: any;
  buckets?: string;
  multiSignOn?: string;
  createdBy?: number | string;
  access?: string;
  userType?: string;
};
const regNew = /^[\w.-]+@(aesl\.in|aakashedu\.tech)$/;
export const emailPattern = {
  value: new RegExp(regNew, "ig"),
  message: "Enter a valid email address.",
};
export type useAPIType = {
  makeRequest: () => void;
  loading: boolean;
  responseData: any;
  error: any;
};

export interface UserFormInterface {
  region?: any;
  selectedUser?: any;
  UserRoles?: any;
  onRequestClose?: any;
  setRefresh?: any;
  formLoading?: boolean;
}

const ref = React.createRef<HTMLInputElement>();
export const UsermManagementForm = ({
  region,
  selectedUser,
  UserRoles,
  onRequestClose,
  setRefresh,
  formLoading,
}: UserFormInterface) => {
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<LoginFormFields>();
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const createdUserGTMData = useRef<any>(null);
  const modifiedUserGTMData = useRef<any>(null);
  const { masters } = useMasterContext();
  const [singleUSerData, setSingleUserData] = useState<any>(
    selectedUser != undefined ? selectedUser : null
  );
  const [isRoleHaveAllAccess, setIsRoleHaveAllAccess] = useState<any>(false);
  const [isAcademicCounsellorRole, setIsAcademicCounsellorRole] =
    useState<any>(false);
  const [branchOptions, setBranchOptions] = useState<any>(masters?.branches);
  const { makeRequest: postLoginData } = usePutPostAPI(
    (data: any) => {
      setSingleUserData(data);
      pushToDataLayerForGTM({
        event: "ag_user_management_create_user_fex",
        USER_ROLE: createdUserGTMData.current?.USER_ROLE,
        STREAM: createdUserGTMData.current?.STREAM,
        BRANCH_NAME: createdUserGTMData.current?.BRANCH_NAME,
      });
      ToastDispatch({
        isOpen: true,
        type: "Success",
        message: data?.detailMessage,
      });
      setRefresh(new Date().getMilliseconds());
      onRequestClose();
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error?.response?.data?.message || error?.message,
      });
    },
    "POST"
  );
  const { makeRequest: updateLoginData } = usePutPostAPI(
    (data: any) => {
      pushToDataLayerForGTM({
        event: "ag_user_management_modify_user_fex",
        EMPLOYEE_ID: modifiedUserGTMData.current?.EMPLOYEE_ID,
        CHANGE_TYPE: modifiedUserGTMData.current?.CHANGE_TYPE,
      });
      ToastDispatch({
        isOpen: true,
        type: "Success",
        message: data?.detailMessage,
      });
      setRefresh(new Date().getMilliseconds());
      onRequestClose();
      //setSingleUserData(data);
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error?.response?.data?.code || error?.message,
      });
    },
    "PUT"
  );
  useEffect(() => {
    if (
      singleUSerData &&
      singleUSerData != null &&
      !Array.isArray(singleUSerData?.region)
    ) {
      const regionIds = singleUSerData?.region?.split(",");
      handleOptionForBranches(regionIds);
    }
    if (
      (singleUSerData &&
        singleUSerData != null &&
        singleUSerData?.fexRole == "National Head") ||
      singleUSerData?.fexRole == "NAD Team"
    ) {
      setIsRoleHaveAllAccess(true);
      setIsAcademicCounsellorRole(false);
    }
    if (
      singleUSerData &&
      singleUSerData != null &&
      singleUSerData?.fexRole == "Academic Counsellor"
    ) {
      setIsRoleHaveAllAccess(false);
      setIsAcademicCounsellorRole(true);
    }
  }, [singleUSerData]);
  console.log(
    userInfo?.userStreams,
    userInfo?.subjectsListing,
    "userInfo?.subjectsListing"
  );
  const onSubmit = handleSubmit((data) => {
    const isAllAccessRoleSelected = ["National Head", "NAD Team"].includes(
      data?.fexRole?.value
    );
    const isAcademicCounsellorSelected = ["Academic Counsellor"].includes(
      data?.fexRole?.value
    );
    const joinOptionLabels = (options: any) =>
      (Array.isArray(options) ? options : [])
        .map((item: any) => item?.label)
        .filter(Boolean)
        .join(", ");
    let streamids =
      data.stream &&
      Array.isArray(data.stream) &&
      data.stream.map((item: any) => item.value);
    let subjectids =
      data.subjects &&
      Array.isArray(data.subjects) &&
      data.subjects.map((item: any) => Number(item.value));
    let branchids =
      data?.branch &&
      Array.isArray(data?.branch) &&
      data.branch.map((item: any) => item.id);
    let regionids =
      data?.region &&
      Array.isArray(data?.region) &&
      data.region.map((item: any) => item.value);
    if (isAllAccessRoleSelected) {
      regionids = region.map((item: any) => item.value);
      branchids = "all";
    }
    if (isAcademicCounsellorSelected) {
      streamids =
        userInfo?.userStreams &&
        userInfo?.userStreams.map((item: any) => item.value);
      subjectids = userInfo?.subjectsListing.map((item: any) => {
        if (item.value && item.value != null) {
          return item.value;
        }
      });
    }
    const Obj = {
      name: data.name,
      email: data.email,
      password: data.employeeId + "_" + new Date().getMilliseconds(),
      employeeId: data.employeeId,
      supervisorEmail: data.supervisorEmail,
      user_theme: "CMS_THEME_NAME",
      region: regionids.join(","),
      branch: isAllAccessRoleSelected ? "all" : branchids.join(","),
      status: data?.status?.value,
      fexRole: data?.fexRole?.value,
      streamIds: streamids.join(","),
      subjects: subjectids,
      multiSignOn: "1",
      createdBy: userInfo?.id,
      access: "2",
      userType: "Digital",
    };
    if (singleUSerData && singleUSerData?.id) {
      const bucketids = singleUSerData.buckets.map((item: any) => item.value);
      const newObj = { ...singleUSerData, ...Obj };
      newObj["name"] =
        data?.name && data?.name != null ? data?.name : singleUSerData["name"];
      newObj["email"] =
        data?.email && data?.email != null
          ? data?.email
          : singleUSerData["email"];
      newObj["employeeId"] =
        data?.employeeId && data?.employeeId != null
          ? data?.employeeId
          : singleUSerData["employeeId"];
      newObj["supervisorEmail"] =
        data?.supervisorEmail && data?.supervisorEmail != null
          ? data?.supervisorEmail
          : singleUSerData["supervisorEmail"];
      newObj["buckets"] = bucketids.join(",");
      newObj["stream"] = streamids.join(",");
      newObj["stream_id"] = streamids.join(",");
      newObj["username"] = singleUSerData?.userName;
      delete newObj["streamIds"];
      delete newObj["streams"];
      delete newObj["userId"];
      delete newObj["userName"];
      const isStatusChanged =
        String(selectedUser?.status) !== String(data?.status?.value);

      modifiedUserGTMData.current = {
        EMPLOYEE_ID: data?.employeeId || singleUSerData?.employeeId,
        CHANGE_TYPE: isStatusChanged ? "STATUS_CHANGED" : "DETAILS_CHANGED",
      };
      updateLoginData(
        BASE_URL + UPDTAE_SINGLE_USER + "/" + singleUSerData?.id,
        newObj
      );
    } else {
      // Build GTM payload from the same resolved values that are sent to the API.
      // For Academic Counsellor the stream select is disabled, so data.stream is
      // null and the streams actually assigned come from userInfo.userStreams.
      const gtmStreamOptions = isAcademicCounsellorSelected
        ? userInfo?.userStreams
        : data?.stream;
      const gtmBranchOptions = isAllAccessRoleSelected ? [] : data?.branch;

      createdUserGTMData.current = {
        USER_ROLE: data?.fexRole?.value,
        STREAM:
          joinOptionLabels(gtmStreamOptions) ||
          (isAcademicCounsellorSelected ? "all" : ""),
        BRANCH_NAME: isAllAccessRoleSelected
          ? "all"
          : joinOptionLabels(gtmBranchOptions),
      };
      postLoginData(BASE_URL + POST_CREATE_USER, Obj);
    }
  });

  const handleSelectedOptionFromSelect = (type: string, data: any) => {
    const singleUSerDataCopy = { ...singleUSerData };
    singleUSerDataCopy[type] = data;
    if (type == "region") {
      singleUSerDataCopy["branch"] = null;
      setValue("branch", null);
    }
    setSingleUserData({ ...singleUSerDataCopy });
  };

  const handleOptionForBranches = (regionIds: any) => {
    const newRegionids =
      regionIds &&
      Array.isArray(regionIds) &&
      regionIds.map((item: any) => String(item));
    if (newRegionids && masters && Array.isArray(masters?.branches)) {
      const filteredbranches = masters?.branches.filter((item: any) =>
        newRegionids.includes(String(item.region))
      );

      setBranchOptions(filteredbranches);
    }
  };
  const handleSelectedRoleAccess = (role: any) => {
    if (role == "National Head" || role == "NAD Team") {
      setIsRoleHaveAllAccess(true);
      setIsAcademicCounsellorRole(false);
    } else if (role == "Academic Counsellor") {
      setIsAcademicCounsellorRole(true);
      setIsRoleHaveAllAccess(false);
    } else {
      setIsRoleHaveAllAccess(false);
      setIsAcademicCounsellorRole(false);
    }
  };

  const userName: any = {
    style: {
      flexDirection: "column",
    },
  };

  return (
    <div>
      {formLoading ? (
        <Spinner color="info" />
      ) : (
        <form onSubmit={onSubmit}>
          <div className="formContainer">
            <Row className="d-flex flex-row align-items-center mt-2 mb-3">
              <Col xs="3" sm="3">
                <label className="pt-2">Name</label>
              </Col>
              <Col xs="8" sm="8">
                <FormInput<LoginFormFields>
                  disabled={false}
                  ref={ref}
                  id="name"
                  type="text"
                  name="name"
                  defaultValue={singleUSerData?.name}
                  placeholder="Enter name"
                  className="d-flex mw-100 flex-column"
                  register={register}
                  rules={
                    userInfo?.fexRole == "Branch EDP" &&
                    singleUSerData != null &&
                    singleUSerData?.id != undefined
                      ? { required: false }
                      : {
                          required: "You must enter Name.",
                        }
                  }
                  errors={errors}
                  {...userName}
                />
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label className="pt-2">Email</label>
              </Col>
              <Col xs="8" sm="8">
                <FormInput<LoginFormFields>
                  disabled={
                    userInfo?.fexRole == "Branch EDP" &&
                    singleUSerData != null &&
                    singleUSerData?.id != undefined
                  }
                  ref={ref}
                  id="email"
                  type="email"
                  name="email"
                  defaultValue={singleUSerData?.email}
                  placeholder="Enter email address"
                  className="d-flex mw-100 flex-column"
                  register={register}
                  rules={
                    userInfo?.fexRole == "Branch EDP" &&
                    singleUSerData != null &&
                    singleUSerData?.id != undefined
                      ? { required: false }
                      : {
                          required: "You must enter valid email address.",
                          pattern: emailPattern,
                        }
                  }
                  errors={errors}
                  {...userName}
                />
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label className="pt-2">Employee Id</label>
              </Col>
              <Col xs="8" sm="8">
                <FormInput<LoginFormFields>
                  disabled={false}
                  ref={ref}
                  id="employeeId"
                  type="text"
                  name="employeeId"
                  defaultValue={singleUSerData?.employeeId}
                  placeholder="Enter employee Id"
                  className="d-flex mw-100 flex-column"
                  register={register}
                  rules={
                    userInfo?.fexRole == "Branch EDP" &&
                    singleUSerData != null &&
                    singleUSerData?.id != undefined
                      ? { required: false }
                      : {
                          maxLength: {
                            value: 15,
                            message: "Value must be less than 16 characters",
                          },
                          required: "You must enter employee id.",
                        }
                  }
                  errors={errors}
                  {...userName}
                />
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label className="pt-1">Role</label>
              </Col>
              <Col xs="8" sm="8">
                <SingleSelectHookForm
                  disabled={
                    singleUSerData &&
                    singleUSerData.employeeId &&
                    userInfo?.fexRole === "Branch EDP"
                      ? ["National Head", "NAD Team", "Regional Head"].includes(
                          singleUSerData.fexRole
                        )
                        ? true
                        : false
                      : false
                  }
                  error={errors}
                  controlName={control}
                  placeholder="Select role"
                  width="100%"
                  isInPerformance={false}
                  options={UserRoles}
                  menuPlacement="bottom"
                  isClearable={false}
                  isSearchable={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name={"fexRole"}
                  register={register}
                  rules={{
                    required: "You must select user role.",
                  }}
                  onChange={(selected: any) => {
                    handleSelectedOptionFromSelect("fexRole", selected?.value);
                    handleSelectedRoleAccess(selected?.value);
                  }}
                  defaultValue={getOptionIndex(
                    singleUSerData?.fexRole,
                    UserRoles
                  )}
                />
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label className="pt-2">Supervisor Email</label>
              </Col>
              <Col xs="8" sm="8">
                <FormInput<LoginFormFields>
                  disabled={false}
                  ref={ref}
                  id="supervisor email"
                  type="text"
                  name="supervisorEmail"
                  defaultValue={singleUSerData?.supervisorEmail}
                  placeholder="Enter supervisor email"
                  className="d-flex mw-100 flex-column"
                  register={register}
                  rules={
                    userInfo?.fexRole == "Branch EDP" &&
                    singleUSerData != null &&
                    singleUSerData?.id != undefined
                      ? { required: false }
                      : {
                          required: "You must enter valid email address.",
                          pattern: emailPattern,
                        }
                  }
                  errors={errors}
                  {...userName}
                />
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label>Region</label>
              </Col>
              <Col xs="8" sm="8">
                <SelectHookForm
                  isDisabled={isRoleHaveAllAccess}
                  error={errors}
                  required={isRoleHaveAllAccess ? false : true}
                  controlName={control}
                  placeholderLabel="Select region"
                  width="100%"
                  isInPerformance={true}
                  options={region}
                  menuPlacement="top"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  name={"region"}
                  register={register}
                  rules={
                    isRoleHaveAllAccess
                      ? { required: false }
                      : {
                          required: "You must select region.",
                        }
                  }
                  onChange={(selected: any) => {
                    const regionIds = selected.map((item: any) => item.value);
                    handleSelectedOptionFromSelect("region", regionIds);
                    setBranchOptions([]);
                    handleOptionForBranches(regionIds);
                  }}
                  defaultValue={returnMultipleValues(
                    singleUSerData?.region,
                    region
                  )}
                />
                {isRoleHaveAllAccess ? (
                  <Typography variant="forminfo" color="black">
                    {singleUSerData?.fexRole} users will have all the region by
                    default
                  </Typography>
                ) : null}
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label>Branch</label>
              </Col>
              <Col xs="8" sm="8">
                <SelectHookForm
                  isDisabled={isRoleHaveAllAccess || !branchOptions.length}
                  error={errors}
                  required={isRoleHaveAllAccess ? false : true}
                  controlName={control}
                  placeholderLabel="Select branch"
                  width="100%"
                  isInPerformance={true}
                  options={branchOptions}
                  menuPlacement="top"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  name={"branch"}
                  isSelectAll={true}
                  register={register}
                  rules={
                    isRoleHaveAllAccess
                      ? { required: false }
                      : {
                          required: "You must select branch.",
                        }
                  }
                  onChange={(selected: any) => {
                    const branchids = selected.map((item: any) => item.id);
                    handleSelectedOptionFromSelect("branch", branchids);
                  }}
                  defaultValue={getOptionIndexMultiForBranch(
                    singleUSerData?.branch,
                    branchOptions
                  )}
                />

                {isRoleHaveAllAccess ? (
                  <Typography variant="forminfo" color="black">
                    {singleUSerData?.fexRole} users will have all the branches
                    by default
                  </Typography>
                ) : null}
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label>Stream</label>
              </Col>
              <Col xs="8" sm="8">
                <SelectHookForm
                  //   isDisabled={
                  //     userInfo?.fexRole == "Branch EDP" &&
                  //     singleUSerData != null &&
                  //     singleUSerData?.id != undefined
                  //   }
                  isDisabled={isAcademicCounsellorRole}
                  error={errors}
                  required={isAcademicCounsellorRole ? false : true}
                  controlName={control}
                  placeholderLabel="Select stream"
                  width="100%"
                  isInPerformance={true}
                  options={userInfo?.userStreams}
                  menuPlacement="top"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  name={"stream"}
                  register={register}
                  rules={
                    isAcademicCounsellorRole
                      ? {
                          required: false,
                        }
                      : {
                          required: "You must select stream.",
                        }
                  }
                  onChange={(selected: any) => {
                    // const streamIds = selected.map((item: any) => item.value);
                    handleSelectedOptionFromSelect("streams", selected);
                  }}
                  defaultValue={getOptionIndexMultiWithObject(
                    singleUSerData?.streams,
                    userInfo?.userStreams
                  )}
                />
                {isAcademicCounsellorRole ? (
                  <Typography variant="forminfo" color="black">
                    {singleUSerData?.fexRole} users will have all the streams by
                    default
                  </Typography>
                ) : null}
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label>Subject</label>
              </Col>
              <Col xs="8" sm="8">
                <SelectHookForm
                  isDisabled={isAcademicCounsellorRole}
                  error={errors}
                  required={isAcademicCounsellorRole ? false : true}
                  controlName={control}
                  placeholderLabel="Select subject"
                  width="100%"
                  isInPerformance={true}
                  options={userInfo?.subjectsListing}
                  menuPlacement="top"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  name={"subjects"}
                  register={register}
                  rules={
                    isAcademicCounsellorRole
                      ? {
                          required: false,
                        }
                      : {
                          required: "You must select subject.",
                        }
                  }
                  onChange={(selected: any) => {
                    handleSelectedOptionFromSelect("subjects", selected);
                  }}
                  defaultValue={singleUSerData?.subjects}
                />
                {isAcademicCounsellorRole ? (
                  <Typography variant="forminfo" color="black">
                    {singleUSerData?.fexRole} users will have all the subjects
                    by default
                  </Typography>
                ) : null}
              </Col>
            </Row>
            <Row className="d-flex flex-row align-items-center mb-3">
              <Col xs="3" sm="3">
                <label>Status</label>
              </Col>
              <Col xs="8" sm="8">
                <SingleSelectHookForm
                  // isDisabled={
                  //   userInfo?.fexRole == "Branch EDP" &&
                  //   singleUSerData != null &&
                  //   singleUSerData?.id != undefined
                  // }
                  error={errors}
                  required={false}
                  controlName={control}
                  placeholder="Select status"
                  width="100%"
                  isInPerformance={false}
                  options={Status}
                  menuPlacement="top"
                  isClearable={false}
                  isSearchable={true}
                  isSearchableDrop={false}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name={"status"}
                  register={register}
                  onChange={(selected: any) => {
                    handleSelectedOptionFromSelect("status", selected?.value);
                  }}
                  defaultValue={
                    singleUSerData && singleUSerData != null
                      ? getOptionIndex(singleUSerData?.status, Status)
                      : getOptionIndex(1, Status)
                  }
                />
              </Col>
            </Row>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              outline
              type="reset"
              color="aeslPrimary"
              className="mt-3 w-20"
              onClick={() => {
                onRequestClose();
              }}
            >
              Cancel
            </Button>

            <Button
              disabled={
                singleUSerData &&
                singleUSerData.employeeId &&
                userInfo?.fexRole === "Branch EDP"
                  ? ["National Head", "NAD Team", "Regional Head"].includes(
                      singleUSerData.fexRole
                    )
                    ? true
                    : false
                  : false
              }
              type="submit"
              color="aeslPrimary"
              className="mt-3 w-20 text-white"
            >
              Save
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};
